module.exports = __webpack_public_path__ + "img/welding-4.4cc52577.jpg";